import { FC, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Breadcrumb from "../../../../components/common/Breadcrumbs";
import { useGetOrderByOrderIdAndTypeQuery } from "../../ordersApi";
import HoaDetailTabSection from "./HoaDetailTabSection";
import {setShowSidebar} from "../../../../app/globalSlice/globalSlice";
import {useDispatch} from "react-redux";



const HoaEditorDetailPage: FC = () => {

    let { orderId } = useParams();
    const [crumbs, setCrumbs] = useState<any[]>([])


    const orderQuery = useGetOrderByOrderIdAndTypeQuery({ orderId: orderId, orderType: 'OTHER' });

    useEffect(() => {
        if (orderQuery?.data) {
            setCrumbs([
                { content: "Home", url: "/home" },
                { content: "Orders", url: "/orders" },
                { content: orderQuery?.data?.customerOrderNumber, url: "/orders/"+orderId },
                { content: "HOA Certificate Editor", url: "" }
            ])
        }
    }, [orderQuery?.data]);

    document.title = `${orderQuery?.data?.customerOrderNumber} HOA Editor`;

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(setShowSidebar(true));
    }, [dispatch]);

    return (
        <>
            {orderQuery?.data &&
                <div className="px-5 py-5">
                    <Breadcrumb crumbs={crumbs} />
                    <HoaDetailTabSection />
                </div>
            }
        </>
    )

}
export default HoaEditorDetailPage